<template>
  <div class="bind-card">
    <div>
      <!--    <div v-if="info.cashStatus > 0">-->
      <el-steps v-if="info.cashStatus" :active="current">
        <el-step v-for="item in steps" :key="item.title" :title="item.title"/>
      </el-steps>
      <div class="steps-content">
        <div style="margin-top: 150px;" v-if="current == 0">
          <el-form v-if="info.cashStatus" :model="form" ref="form" label-width="120px">
            <el-form-item label="开户账户类型" prop="mchType" :rules="[{required: false, message: '请选择', trigger: 'change'}]">
              <!--              <el-select v-if="isEdit" placeholder="请选择开户账户类型" v-model="form.mchType"-->
              <!--              >-->
              <!--                <el-option v-for="(item, key) in Tool.map2arr($enums.mchType)" :key="key" :label="item.value" :value="item.key"></el-option>-->
              <!--              </el-select>-->
              <el-select v-if="isEdit" v-model="form.mchType" placeholder="请选择开户账户类型" filterable :clearable="false">
                <el-option v-for="(item,index) in Tool.map2arr($enums.mchType)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
              </el-select>
              <div v-else>{{types[info.mchType]}}</div>
            </el-form-item>
            <!-- 个人 -->
            <template>
              <div v-if="form.mchType == 0">
                <el-form-item label="银行卡号" prop="bankCardNo" :rules="[$validate.string2(30)]">
                  <el-input v-if="isEdit" v-model="form.bankCardNo" :maxLength="30" placeholder="请输入" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="银行卡所属银行" prop="eiconBankId" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                  <el-select v-if="isEdit" v-model="form.eiconBankId" filterable placeholder="请选择">
                    <el-option v-for="(item, key) in bankList" :key="key" :value="item.bankNo" :label="item.bankName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>
            <!--             个体 -->
            <template>
              <div v-if="form.mchType == 1">
                <el-form-item label="银行卡号" prop="bankCardNo" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                  <el-input v-if="isEdit" :maxLength="30" placeholder="请输入" v-model="form.bankCardNo" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="银行卡所属银行" prop="eiconBankId" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                  <el-select v-if="isEdit" v-model="form.eiconBankId" filterable placeholder="请选择">
                    <el-option v-for="(item, key) in bankList" :key="key" :value="item.bankNo" :label="item.bankName">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="公司名称" prop="companyName" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                  <el-input v-if="isEdit" :maxLength="30" placeholder="请输入" v-model="form.companyName" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="公司证件类型" prop="companyIdType" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                  <el-select v-if="isEdit" v-model="form.companyIdType" placeholder="请选择开户账户类型" filterable :clearable="false">
                    <el-option v-for="(item,index) in Tool.map2arr($enums.financeIdType2)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
                  </el-select>
                  <div v-else>{{$enums.financeIdType2[info.companyIdType]}}</div>
                </el-form-item>
                <el-form-item label="公司证件号码" prop="companyIdNo">
                  <el-input v-if="isEdit" :maxLength="30" placeholder="请输入" v-model="form.companyIdNo" style="width: 300px"></el-input>
                </el-form-item>
              </div>
            </template>
            <!-- 企业 -->
            <template v-if="form.mchType == 2">
              <el-form-item label="银行卡号" prop="bankCardNo" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                <el-input v-if="isEdit" :maxLength="30" placeholder="请输入" v-model="form.bankCardNo" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="银行卡所属银行" prop="eiconBankId" :rules="[{required: false, message: '请选择', trigger: 'change'}]">
                <el-select v-if="isEdit" v-model="form.eiconBankId" filterable placeholder="请选择">
                  <el-option v-for="(item, key) in bankList" :key="key" :value="item.bankNo" :label="item.bankName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="法人姓名" prop="reprName" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                <el-input v-if="isEdit" :maxLength="30" placeholder="请输入" v-model="form.reprName" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="法人证件类型" prop="reprIdType" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                <el-select v-if="isEdit" v-model="form.reprIdType" placeholder="请选择开户账户类型" filterable :clearable="false">
                  <el-option v-for="(item,index) in Tool.map2arr($enums.financeIdType1)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
                </el-select>
                <div v-else>{{$enums.financeIdType1[info.reprIdType]}}</div>
              </el-form-item>
              <el-form-item label="法人证件号码" prop="reprIdNo" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                <el-input v-if="isEdit" :maxLength="30" placeholder="请输入" v-model="form.reprIdNo" style="width: 300px"></el-input>
              </el-form-item>
            </template>
            <el-form-item v-if="isEdit">
              <!--              <a-button type="primary" ghost style="margin-right: 10px" v-show="info.mchId" @click="handleCancel">取消</a-button>-->
              <el-button type="primary" @click="handleSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--        小额鉴权-->
        <div style="margin-top: 150px;" v-if="current == 1">
          <el-form label-width="100px" :form="form2" ref="form2" @submit="handleSubmit2" style="margin-top: 20px">
            <template>
              <div>
                <el-form-item label="金额" prop="authAmt">
                  <!--                  <el-input-->
                  <!--                    v-if="isEdit"-->
                  <!--                    :maxLength="30"-->
                  <!--                    placeholder="请输入一笔小额随机金额"-->
                  <!--                    v-decorator="['info.authAmt', { initialValue:info['authAmt'], rules: [{ required: true, message: '请输入一笔小额随机金额' }] }]"-->
                  <!--                  />-->
                  <el-input v-if="isEdit" :maxLength="30" placeholder="请输入绑定银行卡收到的小额金额" v-model="form2.authAmt" style="width: 300px"></el-input>
                  <span style="position: absolute;left: 550px;">元</span>
                </el-form-item>
                <el-form-item label="指令号" prop="orderNo">
                  <!--                  <el-input-->
                  <!--                    v-if="isEdit"-->
                  <!--                    :maxLength="30"-->
                  <!--                    placeholder="请输入平安银行所发短信中的指令号"-->
                  <!--                    v-decorator="['info.orderNo', { initialValue:info['orderNo'], rules: [{ required: true, message: '请输入平安银行所发短信中的指令号' }] }]"-->
                  <!--                  />-->
                  <el-input v-if="isEdit" :maxLength="30" placeholder="请输入平安银行所发短信中的指令号" v-model="form2.orderNo" style="width: 300px"></el-input>
                </el-form-item>
              </div>
            </template>
            <el-form-item v-if="isEdit">
              <el-button v-if="current == 1" style="margin-right: 20px" @click="prev">
                上一步
              </el-button>
              <!--              <a-button type="primary" ghost style="margin-right: 10px" v-show="info.mchId" @click="handleCancel">取消</a-button>-->
              <el-button type="primary" @click="handleSubmit2">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--        查询余额-->
        <div style="margin-top: 150px;" v-if="current == 2">
          <el-form :form="form3" @submit="handleSubmit3" style="margin-top: 20px">
            <template>
              <div style="display: flex;justify-content: space-around">
                <div style="width: 50%;">
                  <div style="font-weight: bold">账户主体信息</div>
                  <el-form-item label="待结算金额" prop="amountToBeSettled">
                    <span>{{cash.acctAvailBalEye ? cash.amountToBeSettled2:cash.amountToBeSettled}}<i style="margin-left: 5px;" :class="cash.acctAvailBalEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                                      @click="changeEye('acctAvailBalEye', cash.acctAvailBalEye)"/></span>
                    <!--                    <a-input-password-->
                    <!--                      v-if="isEdit"-->
                    <!--                      :maxLength="30"-->
                    <!--                      placeholder=""-->
                    <!--                      readOnly-->
                    <!--                      v-decorator="['cash.acctAvailBal', { initialValue:cash['acctAvailBal'], rules: [{ required: true, message: '' }] }]"-->
                    <!--                    />-->
                    <span style="position: absolute;">元</span>
                  </el-form-item>
                  <el-form-item label="已结算收益" prop="settledEarnings">
                    <span>{{cash.cashAmtEye ? cash.settledEarnings2:cash.settledEarnings}}<i style="margin-left: 5px;" :class="cash.cashAmtEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                             @click="changeEye('cashAmtEye', cash.cashAmtEye)"/></span>
                    <!--                    <a-input-password-->
                    <!--                      v-if="isEdit"-->
                    <!--                      :maxLength="30"-->
                    <!--                      placeholder=""-->
                    <!--                      readOnly-->
                    <!--                      v-decorator="['cash.cashAmt', { initialValue:cash['cashAmt'], rules: [{ required: true, message: '' }] }]"-->
                    <!--                    />-->
                    <span style="position: absolute;">元</span>
                  </el-form-item>
                </div>
                <div style="width: 50%;">
                  <!--                  <div style="font-weight: bold">提现</div>-->
                  <el-form-item label="已结算金额" prop="amountSettled">
                    <span>{{cash.amountSettledEye ? cash.amountSettled2:cash.amountSettled}}<i style="margin-left: 5px;" :class="cash.amountSettledEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                               @click="changeEye('amountSettledEye', cash.amountSettledEye)"/></span>
                    <!--                    <a-input-->
                    <!--                      v-if="isEdit"-->
                    <!--                      :maxLength="30"-->
                    <!--                      placeholder="请输入需要提现金额"-->
                    <!--                      v-decorator="['cash.cashAmount', { initialValue:cash['cashAmount'], rules: [{ required: true, message: '请输入需要提现金额' }] }]"-->
                    <!--                    />-->
                    <span style="position: absolute;">元</span>
                  </el-form-item>
                </div>
              </div>
            </template>
            <!--            <a-form-item v-bind="tailFormItemLayout" v-if="isEdit">-->
            <!--              &lt;!&ndash;              <a-button type="primary" ghost style="margin-right: 10px" v-show="info.mchId" @click="handleCancel">取消</a-button>&ndash;&gt;-->
            <!--              <a-button type="primary" @click="handleSubmit3">提交</a-button>-->
            <!--            </a-form-item>-->
          </el-form>
        </div>
      </div>
    </div>
    <div v-if="!info.cashStatus" style="margin-top:150px;text-align: center">
      <img src="../../assets/img_cash@2x.png" alt="" style="width: 200px;margin-bottom: 20px;">
      <p>1.请先在【账户主体信息】页面创建账户信息；</p>
      <p>2.账户信息审核通过后，才能绑定银行卡及提现。</p>
    </div>
    <div v-if="info.cashStatus > 0">
      <p style="font-weight: bold">说明</p>
      <p style="font-weight: bold">银行卡商户类型</p>
      <p>若是选择了“企业商户”类型那么银行卡需要以公司名开户，银行卡属于企业名下；若是选择了“个体工商户”类型那么银行卡需要以公司法人开户，银行卡也需要在企业名下</p>
      <!--      <p style="font-weight: bold">更换绑定的银行卡</p>-->
      <!--      <div>若是需要更换已绑定的银行卡，请点击此处 <span style="color:#1890ff;cursor: pointer">申请解绑银行卡</span></div>-->
    </div>
    <div v-if="info.cashStatus" ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe size="medium">
        <el-table-column prop="settlementName" label="账单名称"></el-table-column>
        <el-table-column prop="totalAmountReceivable" label="审核金额"></el-table-column>
        <el-table-column prop="settlementStatus" label="结算状态">
          <template slot-scope="scope">
            {{$enums.settlementStatus[scope.row.settlementStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="confirmStatus" label="确认状态">
          <template slot-scope="scope">
            {{$enums.confirmStatus[scope.row.confirmStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.confirmStatus == 0 && scope.row.settlementStatus != 6" size="mini" type="text" @click="settlementConfirm(scope.row)">确认结算单</el-button>
            <el-button v-if="scope.row.confirmStatus == 0 && scope.row.settlementStatus != 6" size="mini" type="text" @click="settlementRefund(scope.row)" style="color: #D9001B;">结算单打回</el-button>
            <el-button size="mini" type="text" @click="$router.push(`settlement-detail?settlementId=${scope.row.settlementId}`)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--      <div style="margin-top: 20px;">-->
      <!--        <el-pagination class="text-center" background-->
      <!--                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"-->
      <!--                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"-->
      <!--                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>-->
      <!--      </div>-->
    </div>
  </div>
</template>
<script>
/* eslint-disable */

// import ApiFinanceProxy from '@/apis/api-finance-proxy'
import Tool from '../../common/tool'

export default {
  name: 'bind-card',
  data () {
    return {
      types: {
        0: '个人商户',
        1: '个体工商户',
        2: '企业商户'
      },
      current: 0,
      steps: [
        {
          title: '绑定银行卡'
        },
        {
          title: '绑卡鉴权校验'
        },
        {
          title: '查询余额/提现'
        }
      ],
      agentId: this.$store.state.currentUserInfo.agentId,
      agentName: this.$store.state.currentUserInfo.agentName,
      form: { mchType: 2 },
      form2: {},
      form3: {},
      isEdit: true,
      info: {},
      cash: {},
      mchType: 2,
      oldMchType: 0,
      oldIdType: '',
      bankList: [],
      data: [],
      settlementInfo: {},
      page: []
    }
  },
  // async beforeCreate () {
  //   Tool.setTitle('', this.$route.path)
  // },
  async created () {
    this.bankList = await this.$HTTP.ApiFinanceProxy.getMerchantlistBank()
    await this.initData()
    // this.settlementInfo = await ApiFinanceProxy.getSettlementInfo(this.info.mchId)
    await this.search()
  },
  methods: {
    async initData () {
      const data = await this.$HTTP.ApiFinanceProxy.getMerchantInfo(this.agentId) || {}
      if (data) {
        this.info = data
        this.form = data
        this.mchType = this.info.mchType
        if (this.info.companyIdType) {
          this.info.companyIdType = Number(this.info.companyIdType)
        }
        if (data.cashStatus == 1) {
          this.current = 0
          this.form = { mchType: 2 }
        } else if (data.cashStatus == 2) {
          this.current = 1
        } else if (data.cashStatus == 3 || data.cashStatus == 4) {
          this.current = 2
          const data = await this.$HTTP.ApiFinanceProxy.getSettlementDetail({
            appId: this.info.appId,
            organizationId: this.agentId,
            mchId: this.info.mchId
          }) || {}
          data.amountToBeSettled2 = '******'
          data.acctAvailBalEye = true
          data.settledEarnings2 = '******'
          data.cashAmtEye = true
          data.amountSettled2 = '******'
          data.amountSettledEye = true
          this.cash = data
        }
      } else {
        this.info = {}
      }
    },
    changeEye (key, value) {
      this.cash[key] = !value
    },
    // 过滤
    // filterOption (inputValue, option) {
    //   return (
    //     option.componentOptions.children[0].text.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
    //   )
    // },
    async next () {
      this.current++
      if (this.current == 2) {
        const data = await this.$HTTP.ApiFinanceProxy.getSettlementDetail({
          appId: this.info.appId,
          organizationId: this.agentId,
          mchId: this.info.mchId
        }) || {}
        this.cash = data
      }
    },
    async prev () {
      const data = await this.$HTTP.ApiFinanceProxy.getMerchantInfo(this.agentId) || {}
      this.info = data
      this.current--
      // this.$nextTick(() => {
      //   this.form.setFieldsValue({
      //     info: this.info
      //   })
      // })
      this.$forceUpdate()
    },
    mchTypeChange (value) {
      this.mchType = value
      this.form.setFieldsValue({
        info: this.info
      })
    },
    async handleSubmit () {
      try {
        let confirm = await this.$confirm('请确保填写的信息无误，提交后不能更改账户信息', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let isOK = await this.Tool.checkForm(this.$refs['form'])
          if (isOK) {
            await this.$HTTP.ApiFinanceProxy.merchantBind({
              ...this.form,
              mchId: this.info.mchId
            })
            this.$message.success('操作成功')
            await this.next()
            await this.initData()
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async handleSubmit2 () {
      try {
        let confirm = await this.$confirm('请确保填写的信息无误，提交后不能更改账户信息', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let isOK = await this.Tool.checkForm(this.$refs['form2'])
          if (isOK) {
            await this.$HTTP.ApiFinanceProxy.merchantCheck({
              ...this.form2,
              mchId: this.info.mchId
            })
            this.$message.success('操作成功')
            await this.next()
            await this.initData()
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    handleSubmit3 () {
      const that = this
      this.form3.validateFields((err, values) => {
        console.log('fdafd:', values)
        if (!err) {
          const confirm = that.$confirm({
            title: '提示',
            content: '请确保填写的信息无误',
            okText: '确认',
            cancelText: '取消',
            async onOk () {
              try {
                await await this.$HTTP.ApiFinanceProxy.merchantApplyCash({
                  ...values.cash,
                  mchId: that.info.mchId,
                  applyPerson: that.$store.state.currentUserInfo.perm.realName
                })
                that.$message.success('提现成功')
                await that.initData()
                that.$nextTick(() => {
                  that.form3.resetFields()
                })
              } catch (e) {
                confirm.destroy()
              }
            }
          })
        }
      })
    },
    handleCancel () {
      this.isEdit = false
      this.info.mchType = this.oldMchType
      this.info.idType = this.oldIdType
      this.mchType = this.oldMchType
      this.form.setFieldsValue({
        info: this.info
      })
    },
    async search () {
      try {
        const datas = await this.$HTTP.ApiFinanceProxy.getSettlementSchoolList({
          organizationId: this.info.mchId,
          appId: '21188075522202009676dfd1c0522d03',
          pageSize: this.page.pageSize,
          pageNum: this.page.current
        })
        if (datas.list) {
          this.page = datas
        } else {
          this.page = []
        }
      } catch (e) {
        this.loading = false
      }
    },
    async settlementConfirm (row) {
      try {
        let confirm = await this.$confirm('是否确认结算单', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          const param = {
            settlementId: row.settlementId,
            operateCode: 12,
            version: row.version
          }
          await this.$HTTP.ApiFinanceProxy.settlementHandle(param)
          this.$message.success('操作成功')
          await this.search()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async settlementRefund (row) {
      try {
        let confirm = await this.$confirm('是否确认打回', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          const param = {
            settlementId: row.settlementId,
            operateCode: 13,
            version: row.version
          }
          await this.$HTTP.ApiFinanceProxy.settlementHandle(param)
          this.$message.success('操作成功')
          await this.search()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }

}
</script>
<style>
  .bind-card .el-input__inner {
    width: 500px;
  }
</style>
